import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LuMailCheck } from 'react-icons/lu';
import AuthCard from '../components/AuthCard';
import { confirmarCadastro } from '../api/register';
import { useUser } from '../../../config/connection/auth';

/**
 * O link do e-mail de cadastro (`/auth/confirmar?token=...`; Arthur, 22/10/2026). Antes o link ia
 * direto para a API e mostrava uma frase solta em texto puro, o que parecia golpe. Aqui a conta é
 * confirmada e a pessoa vê o resultado com a cara do site. Funciona logado ou não (ver `routes`).
 */
export function ConfirmarCadastro() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const logado = useUser();
    const token = (params.get('token') || '').trim();
    const [situacao, setSituacao] = useState<'confirmando' | 'ok' | 'erro'>(token ? 'confirmando' : 'erro');
    const pedido = useRef(false);

    useEffect(() => {
        // Uma vez só (o StrictMode do desenvolvimento chama o efeito duas vezes).
        if (!token || pedido.current) return;
        pedido.current = true;
        confirmarCadastro(token).then(() => setSituacao('ok')).catch(() => setSituacao('erro'));
    }, [token]);

    const estaLogado = !!logado.data && typeof logado.data !== 'string';
    const seguir = () => navigate(estaLogado ? '/app/dashboard' : '/auth/login');

    if (situacao === 'confirmando') {
        return <AuthCard titulo='Confirmando seu cadastro' subtitulo='Só um instante.'>{null}</AuthCard>;
    }

    if (situacao === 'erro') {
        return (
            <AuthCard titulo='Link não vale mais'>
                <div className='auth-enviado'>
                    <LuMailCheck />
                    <span>
                        Não conseguimos confirmar com este link. Se você já confirmou, é só entrar. Se pediu para
                        recuperar a senha depois do cadastro, use o link do e-mail mais novo: ele também confirma a conta.
                    </span>
                </div>
                <button type='button' className='auth-botao' onClick={seguir}>{estaLogado ? 'Ir para o site' : 'Entrar'}</button>
            </AuthCard>
        );
    }

    return (
        <AuthCard titulo='Cadastro confirmado'>
            <div className='auth-enviado'>
                <LuMailCheck />
                <span>Seu e-mail foi confirmado. Agora é só entrar com o e-mail e a senha que você cadastrou.</span>
            </div>
            <button type='button' className='auth-botao' onClick={seguir}>{estaLogado ? 'Ir para o site' : 'Entrar'}</button>
        </AuthCard>
    );
}
